import history from '../../history';
import Promise from 'bluebird';
import axiosInstance from '../utils/axios';
import debug from 'debug';
import moment from 'moment';
import lazy from 'lazy.js';

const log = debug('circleblack:periods');

let periods = [];

log('Periods', periods);

/* --- actions ---*/
const GET_PERIODS = 'GET_PERIODS';

export const getDefaultTimePeriod = (current, minDate) => {
  const adjustedPeriods = minDate
    ? periods.map(p => p.id === 'MAX' ? {...p, start: minDate, days: moment().diff(moment(minDate, 'YYYY-MM-DD'), 'd')} : p)
    : periods;
  const filteredPeriods = adjustedPeriods.filter(p => p.start >= minDate).sort((a, b) => b.days - a.days);
  log('Filtered Periods', filteredPeriods);
  if (current) {
    const found = filteredPeriods.find(p => p.id === current.id);
    if (found) {
      return found;
    }
  }

  // This is really defaulting logic
  for (let p in filteredPeriods) {
    if (filteredPeriods.hasOwnProperty(p)
      && (filteredPeriods[p].id === 'WEEKS_1' || filteredPeriods[p].id === 'MONTHS_1' || filteredPeriods[p].id === 'MONTHS_3')) {
      return filteredPeriods[p];
    }
  }
  return adjustedPeriods.find(p => p.id === 'MAX');
};

export const getContainerTimePeriods = startDate => lazy(periods)
  .filter(period => period.id === 'MAX' || !!moment(startDate).isSameOrBefore(period.start))
  .sortBy('days')
  .toArray();

export const _getPeriods = () => dispatch => (periods.length
  ? Promise.resolve(dispatch({type: GET_PERIODS, periods}))
  : axiosInstance.get('/periods')
    .then(function setPeriods(res) {
      dispatch({
        type: GET_PERIODS,
        periods: res.data,
      });
    })
    .catch(err => {
      log('failed gathering periods', err);
      history.push('/login');
    }));

/* --- reducer ---*/
export default function reducer(state = periods, action) {
  let newState = {...state};

  switch (action.type) {
    case GET_PERIODS:
      periods = action.periods;
      newState = action.periods;
      break;
    default:
      return state;
  }
  return newState;
}
